const SERVICE_WORKER_VERSION = '2026-03-20-4';
const SERVICE_WORKER_URL = `/service-worker.js?v=${SERVICE_WORKER_VERSION}`;

let serviceWorkerRegistrationPromise: Promise<ServiceWorkerRegistration> | null = null;

export const registerAppServiceWorker = (): Promise<ServiceWorkerRegistration> | null => {
  if (!('serviceWorker' in navigator)) {
    return null;
  }

  if (serviceWorkerRegistrationPromise == null) {
    serviceWorkerRegistrationPromise = navigator.serviceWorker.register(SERVICE_WORKER_URL);
  }

  return serviceWorkerRegistrationPromise;
};

export const getAppServiceWorkerRegistration = async (): Promise<ServiceWorkerRegistration> => {
  if (!('serviceWorker' in navigator)) {
    throw new Error('Service worker nie je v tomto prehliadači dostupný.');
  }

  await registerAppServiceWorker();
  return navigator.serviceWorker.ready;
};
